import { getUserPhoneData, receivesOrderTextsAt } from '../../util/phoneNumber';

// Pages where the reminder would get in the way or is already handled
const HIDDEN_ON_PAGES = [
  'LoginPage',
  'SignupPage',
  'ContactDetailsPage',
  'EmailVerificationPage',
  'PasswordResetPage',
  'StripePayoutPage',
  'CheckoutPage',
];
export const DISMISS_STORAGE_KEY = 'emailVerificationBannerDismissedAt';
export const DISMISS_FOR_MS = 3 * 24 * 60 * 60 * 1000;

// Order updates reach the user by text (verified phone, order texts on), so email can wait
export const getsOrderUpdatesByText = currentUser => {
  const { phoneNumber } = getUserPhoneData(currentUser);
  return !!phoneNumber && receivesOrderTextsAt(currentUser, phoneNumber);
};

export const shouldShowEmailVerificationBanner = ({
  currentUser,
  hasListingsOrOrders,
  currentPage,
  dismissedAt,
  now = Date.now(),
}) => {
  if (!currentUser?.id || currentUser.attributes?.emailVerified !== false) {
    return false;
  }
  if (!hasListingsOrOrders || HIDDEN_ON_PAGES.includes(currentPage)) {
    return false;
  }
  if (dismissedAt && now - dismissedAt < DISMISS_FOR_MS) {
    return false;
  }
  return !getsOrderUpdatesByText(currentUser);
};
